import React from 'react';
import { SmallText, TextLabel } from 'ds/components/typography';
import { TableColumn } from 'ds/components/table';
import { ColumnRendererProps, BuildingPermitTableColumn } from '../../utils';
import { BuildingPermitColumn } from '../styled';
import { BuildingPermitItem, BuildingPermitLabels } from 'components/insight-summary-renderer/BuildingPermitSummary/types';


export const getBuildingPermitRequestedChangeColumnConfig = (): Partial<TableColumn<BuildingPermitItem>> => ({
  width: '40%',
  gap: 5,
});

export const BuildingPermitRequestedChangeColumn: React.FC<ColumnRendererProps<BuildingPermitItem>> = ({ item }) => {
  const firstLabel = item.labels.reduce((prev, current) => current.rank > prev.rank ? current : prev, item.labels[0]) as BuildingPermitLabels;
  return (
    <BuildingPermitColumn col={BuildingPermitTableColumn.RequestedChange}>
      <SmallText>
        {item.requestedChange}
      </SmallText>
      {firstLabel ? (
        <TextLabel weight="bold" small>
          {firstLabel.label}
        </TextLabel>
      ) : null}
    </BuildingPermitColumn>
  );
};
